import script from "./InternalPurchaseOrder.vue?vue&type=script&setup=true&lang=ts"
export * from "./InternalPurchaseOrder.vue?vue&type=script&setup=true&lang=ts"

import "./InternalPurchaseOrder.vue?vue&type=style&index=0&id=5513e0d7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5513e0d7"]])

export default __exports__